<template>
  <div class="app-technology-swiper">
    <div class="swiper-container technology">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item,index) in technologyList">
          <div class="technology-show">
            <img class="technologyImg" :src="item.imgUrl" alt="" />
            <p><span>{{item.name}}</span>{{item.duty}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="content-box">
      <div class="content">
        {{technologyContent}}
      </div>
      <div class="manifesto">
        {{technologyManifesto}}
      </div>
    </div>
  </div>
</template>
<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  export default {
    name: '',
    data() {
      return {
        technologyContent:'',
        technologyManifesto:''
      };
    },
    props: {
      technologyList: Array
    },
    computed: {},
    components: {},
    methods: {
      updateActive: function (index) {
        this.technologyContent = this.technologyList[index].content;
        this.technologyManifesto = this.technologyList[index].manifesto;
      },
      technologySwiper: function () {
        this.technologySwiper = new Swiper('.technology', {
          slidesPerView: 2,
          spaceBetween: 20,
          initialSlide: 1,
          centeredSlides: true,
          effect: 'coverflow',
          coverflow: {
            rotate: 0,
            stretch: 0,
            depth: 160,
            modifier: 1,
            slideShadows: false
          },
          onTransitionEnd: (swiper) => {
            let index = swiper.activeIndex;
            this.updateActive(index);
          }
        });
      }
    },
    created: function () {
    },
    mounted: function () {
      this.technologySwiper();
    }
  };
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .app-technology-swiper {
    padding:0 0.3rem;
    .swiper-container {
      .swiper-wrapper {
        .technologyImg {
          width: 100%;
        }
      }
      .swiper-slide {
        width: 2.2rem;
        text-align: center;
        .technology-show{
          cursor: pointer;
          position: relative;
          z-index:2;
          border: 1px solid #fbedcf;
          background: $color-4;
          .technologyImg {
            width:100%;
          }
          p{
            height:0.9rem;
            color:$color-1;
            font-size:0.16rem;
            padding:0.1rem 0;
            span{
              color:#ffc63d;
            }
          }
        }
        .technology-hover{
          position: relative;
          z-index:1;
          cursor: pointer;
          display: none;
          opacity:0;
          .technologyImg {
            width:100%;
          }
          p{
            height:0.9rem;
            color:$color-1;
            font-size:0.3rem;
            padding:0.1rem 0;
            span{
              color:#ffc63d;
            }
          }
        }
      }
    }
    .content-box{
      height:3.3rem;
      .content{
        font-size:0.25rem;
        color:#555555;
        text-align: justify;
        margin-top:0.2rem;
      }
      .manifesto{
        font-size:0.25rem;
        color:#555555;
        text-align: justify;
        margin-top:0.2rem;
        padding-bottom:0.4rem;
      }
    }
  }
</style>
